<div id="tabs">
	<dx-tabs
		#apiTabs
		[dataSource]="tabs"
		[selectedIndex]="0"
		(onItemClick)="selectTab($event)"
	></dx-tabs>
	<ng-content></ng-content>
</div>
